import { nanoid } from 'nanoid';

export class SessionManager {
  private readonly storageKey: string;

  constructor(storagePrefix: string = 'web-chat') {
    this.storageKey = `${storagePrefix}-session-id`;
  }

  getOrCreateSessionId(customSessionId?: string): string {
    if (customSessionId) {
      this.setSessionId(customSessionId);
      return customSessionId;
    }

    let sessionId = localStorage.getItem(this.storageKey);

    if (!sessionId || sessionId.length < 16 || sessionId.length > 64) {
      sessionId = nanoid(32);
      localStorage.setItem(this.storageKey, sessionId);
    }

    return sessionId;
  }

  setSessionId(sessionId: string): void {
    localStorage.setItem(this.storageKey, sessionId);
  }

  clearSessionId(): void {
    localStorage.removeItem(this.storageKey);
  }

  getSessionId(): string | null {
    return localStorage.getItem(this.storageKey);
  }
}
